export default __webpack_public_path__ + "static/media/fire-1.bb39531c.png";